<div class=" row wrapper border-bottom white-bg page-heading info-projeto">
  <div class="col-lg-10 title-projeto">
    <h2>Reunião - {{title| titlecase}}</h2>
  </div>
</div>
<nav class="tabs-container nav-menu">
  <ul class="nav nav-tabs" role="tablist">
    <ng-container *ngFor="let item of data">
      <li *ngIf="item.showInCreate || title == 'editar' ">
        <a [class.active]="isActive(item.id)" (click)="navigate(item.id)">
          {{item.label}}
        </a>
      </li>
    </ng-container>
  </ul>
</nav>
<section class="modulo-reuniao">
  <router-outlet></router-outlet>
</section>